import { isNil } from 'lodash';
import jwt from 'jsonwebtoken';

const publicKey = '-----BEGIN PUBLIC KEY-----\n'
  + 'MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEUCRsQawpQLYKqPXfE2+dcE5+39ES\n'
  + 'h7rhExkvgHyXJgldE2YrrFD1QGdxvN7ZUwpD6fUOvENK57V4vH025KKsRg==\n'
  + '-----END PUBLIC KEY-----\n';

export function getToken(hotelId) {
  const token = localStorage.getItem(`${hotelId}__token`);
  try {
    const t = jwt.verify(token, publicKey);
    return token;
  } catch (err) {
    return null;
  }
}

export function parseToken(hotelId, token = null) {
  if (isNil(token)) {
    token = localStorage.getItem(`${hotelId}__token`);
  }

  try {
    return jwt.verify(token, publicKey);
  } catch (err) {
    return null;
  }
}

export function setToken(hotelId, token) {
  if (!isNil(hotelId) && token !== null && token !== undefined && typeof token !== 'undefined') {
    const t = jwt.verify(token, publicKey);

    localStorage.setItem(`${hotelId}__token`, token);
  }
}

export function clearToken(hotelId) {
  localStorage.removeItem(`${hotelId}__token`);
}



// WEBPACK FOOTER //
// ./src/lib/util/token.js